import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_URL } from './token.service';

import { User } from '../interfaces/user.interface';

import 'rxjs/add/operator/filter';

@Injectable()
export class _UsersService{
  private users: any;
  private url: string = '';

  constructor(private http: HttpClient){ }

  getUsers(){
    return this.http.get(`${API_URL}/users`)
  }
  getUser(id:Number) {
    return this.http.get(`${API_URL}/users/${id}`)
  }
  getCurrentUser() {
    return this.http.get(`${API_URL}/users/0`)
  }
  getUserRoles() {
    return this.http.get(`${API_URL}/user-roles/0`)
  }
  getUserRules() {
    return this.http.get(`${API_URL}/rule/rules/0`)
  }
  getUserInfoByMail(mail:string){
    return this.http.get<Array<User>>(`${API_URL}/users`)
    // .filter( res => {
    //   console.log(res);
    //   return true;
    // })
    // .map(res => res)
    .map( (res) => {
      return res.filter(function(e){
        return e.email === mail
      })[0];
    })
  }

  changePassword(oldPassword, newPassword){
    return this.http.put(`${API_URL}/users/password`, {oldPassword: oldPassword, newPassword: newPassword});
  }

  updateUser(user){
    return this.http.put(`${API_URL}/users`, [user]);
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/users.service.ts